import React from "react";
import type { NotificationItem } from "@components/NotificationsDropdown/NotificationsDropdown.types";
import type { NotificationsOptions } from "@services/notifications/types.ts";

export const useNotificationIndicator = (
  items: NotificationItem[],
  opts?: NotificationsOptions,
) => {
  const idSelector = opts?.idSelector ?? ((n: NotificationItem) => String((n as any).id));

  const unseenIds = React.useMemo(
    () => items.filter((item) => !(item as any).seen).map(idSelector),
    [items, idSelector],
  );

  const [ackIds, setAckIds] = React.useState<Set<string>>(
    () => new Set(items.filter((item) => (item as any).seen).map(idSelector)),
  );

  const hasNew = React.useMemo(() => {
    if (unseenIds.length === 0) return false;
    for (const id of unseenIds) if (!ackIds.has(id)) return true;
    return false;
  }, [unseenIds, ackIds]);

  const acknowledgeNow = React.useCallback(() => {
    setAckIds(new Set([...ackIds, ...unseenIds]));
  }, [unseenIds, ackIds]);

  return { hasNew, acknowledgeNow };
};
